import axios from "axios";

const BASE_URL = "https://fliplyn-b-c.fly.dev";

export const loginUserAPI = async (userType, email, password) => {
  try {
    // ✅ Select correct endpoint
    const endpoint =
      userType === "admin"
        ? `${BASE_URL}/api/admin/auth/login`
        : `${BASE_URL}/api/manager/auth/login`;

    // ✅ Call API
    const response = await axios.post(endpoint, { email, password });
    const data = response.data;

    // ✅ Store token globally for all future requests
    if (data.access_token) {
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${data.access_token}`;
    }

    // ✅ Build unified response structure
    return {
      access_token: data.access_token,
      token_type: data.token_type,
      admin_id: data.admin_id || null,
      manager_id: data.manager_id || null,
    };
  } catch (err) {
    console.error("Login API Error:", err);
    throw (
      err.response?.data ||
      new Error("Unable to connect to the authentication service")
    );
  }
};



export const createStall = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL}/stalls/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error creating stall:", error);
    throw error;
  }
};





export const createCategory = async (formData) => {
  try {
    const res = await axios.post(`${BASE_URL}/categories/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};